<template>
  <div>
    <!-- <Steps :list="list" :step="step_1" /> -->
    <div class="stepContainer">
      <div v-for="(item, index) in list" :key="index">
        <div class="stepcone">
          <div
            class="line"
            v-if="index <= list.length - 1"
            :style="{ width: (10 - list.length) * 48 + '%' }"></div>
          <div
            class="stepItem"
            :class="{
              isactibe: item.success&&step_1 > index,
              stponce: step_1 == index,
              error: isFail && step_1 == 3 && index == step_1,}">
            <i class="el-icon-check"
              v-if="index + 1 < list.length && step_1 > index" style="color: white"></i>
            <span v-if="index + 1 < list.length && step_1 <= index">{{index + 1}}</span>
            <img src="../../assets/np18.png"
              v-if="step_1 != index && index + 1 == list.length"/>
            <img src="../../assets/18.png" v-if="step_1 == 5 && index + 1 == list.length"/>
            <img src="../../assets/down.png" v-if="step_1 == index" alt class="downpng" />
          </div>
          <span
            v-if="isFail && step_1 == 3 && index == step_1"
            class="erroritem stepTitle">审核不通过</span>
          <span
            v-else
            class="stepTitle"
            :class="{
              successtitle: item.success,
              stpotitle: step_1 == index,
              erroritem: item.error,
            }"
            >{{ item.title }}</span
          >
        </div>
      </div>
    </div>
    <div>
      <div v-if="step_1 == 0">
        <Lineconbgtir :labelcontainer="labelcontainer" />
        <div class="infor-c" v-if="!step">
            一、在国内工商管理机关依法注册登记的燃气经营企业、燃气设备设施制造企业、工程设计、咨询服务公司、燃气施工企业、社团组织、相关研究机构、燃气管理机构等单位均可以申请加入协会，经批准成为单位会员。<br>
            二、各单位自愿申请加入贵州省燃气协会，认同《贵州省燃气协会章程》，承诺履行会员权利和义务，按期缴纳会费。<br>
            三、申请入会须提交的资料<br>
            1、《入会申请表》加盖单位公章；<br>
            2、单位营业执照副本复印件（加盖单位公章）、行业资质证书复印件等证明文件。<br>
            四、入会程序<br>
            1、申请单位在线提交入会资料；<br>
            2、协会收到《入会申请表》等有关材料后，在线对材料进行审核和研究通过。<br>
            3、在线审核通过后，入会单位根据协会的有关规定交纳会费，到帐后协会开具电子发票。<br>
            4、单位会员查看并下载电子会员证书。<br>
            联系电话：0851-85817948<br>
            <el-link :href="shouceurl" target="_blank" style="color:blue;">燃气协会系统会员申请操作手册.pdf</el-link>
        </div>
        <div class="infor-c" v-if="applaylevel == 0&&step">
          1.理事单位应当具备的条件： （1）已经成为我协会一般会员；
          （2）建筑业企业施工总承包资质为壹、贰级企业（省外入黔企业必须为壹级资质）、社团组织（含省外入黔社会团体、办事处等）；
          （3）积极开展贵州省建筑业新技术应用示范工程、贵州省建筑业绿色施工示范工程的施工企业。
          （4）省外入黔企业在黔设立有分公司者优先，且在黔纳税连续满2年；
          2．凡满足以上条件的都可申请成为本会理事单位。申请单位首先须经本会秘书处对其进行资格审查（企业营业执照、资质证书、安全生产许可证、入黔企业纳税证明），再报请本会常务理事会（或本会常务理事会授权本会秘书处）批准后，并取得本会秘书处颁发的《贵州省建筑业协会理事单位牌匾及会员证书》，即正式成为本会理事。
          3.凡申请成为理事单位的理事代表，须为企业主要负责人，并热爱本行业、热心本会工作，有较好的协调、组织能力，且具有一定的行业影响力和知名度；
        </div>
        <div class="infor-c" v-if="applaylevel == 1&&step">
          1.常务理事单位应当具备的条件： （1）已是我协会理事单位；
          （2）建筑业企业施工资质为总承包特、壹级企业（省外入黔企业必须为特级）、社团组织（含省外入黔社会团体、办事处等）；
          （3）近三年获得过贵州省“黄果树杯”优质工程的施工企业（非施工企业不作此要求）；
          （4）省外入黔企业须在黔设立有分公司，且在黔纳税连续满2年；
          2.凡具备以上条件的都可申报成为本会常务理事单位。申请单位须经本会秘书处对其进行资格审查（企业营业执照、资质证书、安全生产许可证、获奖证书、入黔企业纳税证明），再报请本会常务理事会（或本会常务理事会授权本会秘书处）批准后，并取得本会秘书处颁发的《贵州省建筑业协会常务理事牌匾及会员证书》，即正式成为本会常务理事。
          3.凡申请成为常务理事单位的常务理事代表，须为企业主要负责人，且热爱本行业、热心本会工作，有较强的组织、协调能力，且具有较好的行业影响力和知名度。
        </div>
        <div class="infor-c" v-if="applaylevel == 2&&step">
          1．副会长单位应当具备的条件： （1）已是我协会常务理事会员；
          （2）建筑业企业施工总承包资质须为特级资质（省外入黔企业须为双特级）、社团组织（含省外入黔团体、办事处）；
          （3）近三年内获得贵州省“黄果树杯”优质工程不低于3个的施工企业（非施工企业不作此要求），并在建筑领域内具备较高的知名度和行业影响力，经营正常，企业信用较好，企业品牌影响力强；
          （4）省外入黔企业必须在黔设立有分公司，且在黔纳税连续满3年；
          2．凡具备以上条件的会员单位都可申请成为本会副会长单位。申请单位须经本会秘书处对其进行资格审查（企业营业执照、资质证书、安全生产许可证、获奖证书、入黔企业纳税证明），再报请本会常务理事会（或本会常务理事会授权本会秘书处）批准后，并取得本会秘书处颁发的《贵州省建筑业协会副会长单位牌匾及会员证书》，即正式成为本会副会长会员。
          3．凡申请成为副会长单位的副会长代表，须为企业主要负责人，且品行优良的业内知名企业家，在业内享有很高的知名度，热爱本行业，热心本会工作，关心本会发展，具有很强的领导、组织协调能力和号召力；
          4．本会副会长单位应发挥其行业影响力，积极支持并参与本会组织的各项活动，配合或参与组织、承办本会区域性、专题性的活动，参与本会其它相关工作；
        </div>
<!--        <Downinpu v-if="!step" :downlist="downlist" />-->
        <Lineconbgtir
          style="margin-top: 20px"
          v-if="!step"
          :labelcontainer="labelcontainertow"
        />
        <div class="flex-left" v-if="!step">
          <el-button
            size="small"
            icon="el-icon-edit"
            style="
              color: #fff;
              border: 1px solid #194abe;
              width: 189px;
              height: 50px;
              font-size: 18px;
              margin-top: 50px;
              background: #194abe;
              margin: 0 auto;"
            class="block-submit"
            @click="now_modify"
            >开始填写资料</el-button>
        </div>
        <Lineconbgtir
          v-if="step"
          :labelcontainer="labelcontainerthree"
          style="margin-top: 20px"
        />
        <div class="upload" v-if="step">
          <el-upload
            class="upload-demo"
            :action="$baseURL + '/api/home/upload/file/apply'"
            :on-preview="handlePreview"
            :data="{ token: token }"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="
              (response, file, fileList) =>
                handleAdd(response, file, fileList, 0)
            "
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            list-type="text"
          >
            <div class="uploadheader">
              <span>企业营业执照</span>
              <el-button
                size="small"
                icon="el-icon-upload2"
                style="color: #194abe"
                >点击选择文件</el-button
              >
              <span
                v-if="showErr"
                class="el-upload__tip margin-left-30"
                slot="tip"
              >
                <i class="el-icon-error"></i
                >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>
        <div class="upload" v-if="step">
          <el-upload
            class="upload-demo"
            :action="$baseURL + '/api/home/upload/file/apply'"
            :on-preview="handlePreview"
            :data="{ token: token }"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="
              (response, file, fileList) =>
                handleAdd(response, file, fileList, 1)
            "
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            list-type="text"
          >
            <div class="uploadheader">
              <span>资质证书</span>
              <el-button
                size="small"
                icon="el-icon-upload2"
                style="color: #194abe"
                >点击选择文件</el-button
              >
              <span
                v-if="showErr"
                class="el-upload__tip margin-left-30"
                slot="tip"
              >
                <i class="el-icon-error"></i
                >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>
        <div class="upload" v-if="step">
          <el-upload
            class="upload-demo"
            :action="$baseURL + '/api/home/upload/file/apply'"
            :on-preview="handlePreview"
            :data="{ token: token }"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="
              (response, file, fileList) =>
                handleAdd(response, file, fileList, 2)
            "
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            list-type="text"
          >
            <div class="uploadheader">
              <span>安全生产许可证</span>
              <el-button
                size="small"
                icon="el-icon-upload2"
                style="color: #194abe"
                >点击选择文件</el-button
              >
              <span
                v-if="showErr"
                class="el-upload__tip margin-left-30"
                slot="tip"
              >
                <i class="el-icon-error"></i
                >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>
        <div class="upload" v-if="step">
          <el-upload
            class="upload-demo"
            :action="$baseURL + '/api/home/upload/file/apply'"
            :on-preview="handlePreview"
            :data="{ token: token }"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="
              (response, file, fileList) =>
                handleAdd(response, file, fileList, 3)
            "
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            list-type="text"
          >
            <div class="uploadheader">
              <span>入黔企业纳税证明</span>
              <el-button
                size="small"
                icon="el-icon-upload2"
                style="color: #194abe"
                >点击选择文件</el-button
              >
              <span
                v-if="showErr"
                class="el-upload__tip margin-left-30"
                slot="tip"
              >
                <i class="el-icon-error"></i
                >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>
        <div class="upload" v-if="step && applaylevel != 0">
          <el-upload
            class="upload-demo"
            :action="$baseURL + '/api/home/upload/file/apply'"
            :on-preview="handlePreview"
            :data="{ token: token }"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="
              (response, file, fileList) =>
                handleAdd(response, file, fileList, 4)
            "
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            list-type="text"
          >
            <div class="uploadheader">
              <span>获奖证书</span>
              <el-button
                size="small"
                icon="el-icon-upload2"
                style="color: #194abe"
                >点击选择文件</el-button
              >
              <span
                v-if="showErr"
                class="el-upload__tip margin-left-30"
                slot="tip"
              >
                <i class="el-icon-error"></i
                >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>
        <div class="redline" v-if="step"></div>
        <el-button
          v-if="step"
          size="small"
          icon="el-icon-check"
          style="background-color: #194abe; color: white; margin-bottom: 20px"
          class="block-submit"
          @click="submite"
          >提交审核</el-button
        >
      </div>

      <div v-if="step_1 == 1||step_1==2">
        <div class="shenhjrkr">
          <img src="../../assets/shenhr.png" alt />
          <p style="font-size: 20px; color: #333333">正在审核中...</p>
          <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
            正在审核您提交的资料，请稍后查看结果
          </p>
        </div>
      </div>
      <div v-if="step_1 == 3">
        <div v-if="isFail">
          <div class="shenhjrkr">
            <img src="../../assets/faile.png" alt />
            <p style="font-size: 16px; color: #e51725">
              未通过原因：{{ info.reject_reason }}
            </p>
            <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
              请修改后重新提交
            </p>
          </div>
            <div class="flex-left" style="padding-left: 0;">
                <el-button
                    size="small"
                    icon="el-icon-edit"
                    style="
              color: #fff;
              border: 1px solid #194abe;
              width: 189px;
              height: 50px;
              font-size: 18px;
              margin-top: 50px;
              background: #194abe;
              margin: 0 auto;"
                    class="block-submit"
                    @click="now_modify">前往修改资料</el-button>
            </div>
        </div>
      </div>
      <div v-if="step_1 == 4" class="shenhjrkr">
        <div v-if="!isFail">
            <img src="../../assets/sucmnke.png" alt />
            <p style="font-size: 16px; color: #333333">资料审核通过</p>
            <p style="font-size: 15px; color: #9fa5ae; margin: 10px 0">
                请线下缴费完成后，联系贵州省燃气协会管理员修改缴费状态及会员身份。<br/>联系电话：0851-85817948
            </p>
<!--            <div class="renewradio">-->
<!--                <div class="renewradio_title">选择支付方式：</div>-->
<!--                <div class="renewradio_content">-->
<!--                    <el-radio-group-->
<!--                        v-model="pay_type"-->
<!--                        size="small"-->
<!--                    >-->
<!--                        <el-radio :label="1">对公支付</el-radio>-->
<!--                        <el-radio :label="0">个人支付</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </div>-->
<!--            </div>-->
<!--            <el-button-->
<!--                style="background-color: #194abe; color: white; width: 118px"-->
<!--                icon="el-icon-check"-->
<!--                @click="pay()">现在支付</el-button>-->
        </div>
      </div>
      <div v-if="step_1 == 5">
        <div class="shenhjrkr">
          <img src="../../assets/failesucee.png" alt />
          <p style="font-size: 16px; color: #333333">申请会员成功</p>
          <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
            {{ state_text }}
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisiblepay"
      width="30%"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <p style="font-size: 16px; color: #333333">请扫下方二维码完成缴费</p>
        <!-- <div id="qrCode" ref="qrCodeDiv" :style="{backgroundImage:'url('+wechat+')'}"></div> -->
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: space-evenly;
          "
        >
          <div class="zhifu">
            <svg class="icon svg-icon" aria-hidden="true" v-html="ccb">
              <svg xmlns="http://www.w3.org/2000/svg" width="400" />
            </svg>
            <img
              style="width: 50px; height: 50px"
              src="../../assets/ccb.jpeg"
              alt
            />
          </div>
          <use xlink:href="#icon-houcangguanlisvg"></use>
        </div>
        <el-button style="color: #194abe; width: 90%" @click="ispaye()">已确定扫码成功</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <img src="../../assets/succes.png" alt />
      <p style="font-size: 20px; color: #333333">申请提交成功</p>
      <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
        请等待审核结果
      </p>
      <el-button style="color: #194abe; width: 90%" @click="know()">我知道了</el-button>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Lineconbgtir from "@/components/Modal/Line";
import Downinpu from "@/components/Modal/Downinpu";
import { Base64 } from "js-base64";
import {
    GetBaseURL,
  GetMember,
  myOrder,
  Apply,
  ApplyInfo,
  ApplyPayment, //支付
} from "../../utils/api.js";
import axios from "axios";
export default {
  name: "Allylist",
  components: {
    // Steps,
    Lineconbgtir,
    Downinpu,
  },
  props: {
    step: {
      type: Boolean,
      default: false,
    },
    applaylevel: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      shouceurl: GetBaseURL + 'user/燃气协会系统会员申请操作手册.pdf',
      state_text: "您的单位已经成为会员",
      step_1: "",
      isFail: false, //审核状态是否失败
      showErr: false,
      token: "",
      lable: "",
      dialogVisiblepay: false,
      dialogVisible: false,
      fileList: [],
      file_urls:[], //传的文档集合
      downlist: [
        {
          name: "贵州省建筑业协会入会申请操作手册",
          type: 1,
        },
      ],
      labelcontainer: {
        lable: "申请须知",
        desc: "Application Notes",
      },
      labelcontainertow: {
        lable: "填写申请表单",
        desc: "DOCUMENT EDIT",
      },
      labelcontainerthree: {
        lable: "开始上传",
        desc: "Document download",
      },
      labelcontaineragain: {
        lable: "重新上传",
        desc: "Document download",
      },
      list: [
        {
          title: "资料上传",
          success: true,
        },
        {
          title: "办公室审核",
          success: true,
        },
          {
              title: "理事会审议",
              success: true,
          },
        {
          title: "审核通过",
          success: true,
        },
        {
          title: "缴纳会费",
          success: true,
        },
        {
          title: "完成",
          success: true,
        },
      ],
      info: {}, //会员信息
      wechat: "", //微信支付二维码
      alipay: "",
      ccb: "", //ccb建行银行支付二维码
      ccb_corporate_url: "", // 对公链接

      pay_type: 1, // 1=对公
    };
  },
  created() {},
  mounted() {
    this.lable = this.$route.query.name;
    // this.initData()
    this.token = "Bearer " + localStorage.getItem("TOKEN");
    console.log(this.token);
    this.initData();
  },
  methods: {
    //限制文件上传大小
    beforeAvatarUpload(file) {
      let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
      if (filesize > 100) {
        this.$message.error("上传文件不能大于100MB");
        return false;
      }
    },
    now_modify() {
      this.$router.push("/applymembership");
    },
    // 初始化数据
    async initData() {
      let info = await ApplyInfo();
      let userinfo = await GetMember();
      this.info = info;
      console.log(456, userinfo);
      switch (userinfo.level) {
        case 1:
          this.state_text = "您的单位已经成为会员";
          break;
        case 2:
          this.state_text = "您的单位已经成为理事单位";
          break;
        case 3:
          this.state_text = "您的单位已经成为常务理事单位";
          break;
        case 4:
          this.state_text = "您的单位已经成为副会长单位";
          break;
      }
      if (this.step == true && info.status == 4) {
        return false;
      }

      if (info.status == 3) {
        this.isFail = true;
      }
      this.step_1 = info.status || 0;
      console.log(132, this.step_1);
    },
    handleAdd(response, file, fileList, index) {
      console.log(index);
      console.log("filtList handleAdd",fileList);
      this.setUrls(fileList, index);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.setUrls(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    //获取上传数组
    setUrls(fileList, index) {
        console.log('setUrls',fileList)
      let urls = [];
      fileList.map((item) => {
        urls.push(item.response.data.url);
      });
      switch (index) {
        case 0:
          this.file_urls["License"] = urls;
          break;
        case 1:
          this.file_urls["certificate"] = urls;
          break;
        case 2:
          this.file_urls["security"] = urls;
          break;
        case 3:
          this.file_urls["paytaxes"] = urls;
          break;
        case 4:
          this.file_urls["Award"] = urls;
          break;
          default:
              this.file_urls = [urls]
              break
      }
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList);
      this.showErr = true;
      let that = this;
      setTimeout(function () {
        that.showErr = false;
        console.log(that.showErr);
      }, 2000);
      console.log(this.showErr);
    },
    formatData(arr) {
        let temp = []
        console.log("format before ", arr)

        temp.push(this.file_urls["License"])
        temp.push(this.file_urls["certificate"])
        temp.push(this.file_urls["security"])
        temp.push(this.file_urls["paytaxes"])
        if (this.file_urls["Award"]&&this.file_urls["Award"].length) {
            temp.push(this.file_urls["Award"])
        }
        console.log("format after ", temp)
        return temp
    },
    submite() {

      let issumbit = true;
      try {
        if (!this.file_urls["License"].length) {
          issumbit = false;
        }
        if (!this.file_urls["certificate"].length) {
          issumbit = false;
        }
        if (!this.file_urls["security"].length) {
          issumbit = false;
        }
        if (!this.file_urls["paytaxes"].length) {
          issumbit = false;
        }
        if (this.applaylevel != 0) {
          if (!this.file_urls["Award"].length) {
            issumbit = false;
          }
        }
      } catch (err) {
        issumbit = false;
      }

      if (issumbit) {

        const data = {
            file_urls: this.formatData(this.file_urls),
        };
        // console.log("提交的data",data);
        Apply(data)
          .then(res => {
            // console.log("返回数据",res);
            this.dialogVisible = true;
            this.step_1 = 2;
          })
          .catch(err => {
            this.$message.error(err);
          });
      } else {
        this.$message({
          message: "请上传文档",
          type: "warning",
        });
      }
    },
    submite1() {
      let issumbit = true;
      console.log("submite1",this.file_urls)
        if(!this.file_urls.length){
            issumbit = false
        }
      if (issumbit) {

        const data = {
            file_urls: this.file_urls,
        };
        console.log("提交的data",data);
        Apply(data)
          .then(res => {
            // console.log("返回数据",res);
            this.dialogVisible = true;
            this.step_1 = 2;
          })
          .catch(err => {
            this.$message.error(err);
          });
      } else {
        this.$message({
          message: "请上传文档",
          type: "warning",
        });
      }
    },
    know() {
      this.dialogVisible = false;
      this.step_1 = 1;
      this.$emit("closepop", 2);
    },
    pay() {
      ApplyPayment(this.info.id).then((res) => {
        // this.wechat = Base64.decode(res.wechat);
        // this.alipay = Base64.decode(res.alipay);
        this.ccb = Base64.decode(res.ccb);
        this.ccb_corporate_url = res.ccb_corporate_url;

        if (this.pay_type == 1) {
          window.open(this.ccb_corporate_url, '_blank');
        } else {
          this.dialogVisiblepay = true;
        }
        this.checkOrder(res.order_id)

        // this.creatQrCode( res.wechat);
      }).catch(err => {
        this.$message.error(err)
      })
      // this.$nextTick(() => {
      // 	//生成二维码的方法
      // 	this.creatQrCode('11111');
      // });
    },
    checkOrder(order_id) {
        let timer = null;
        let timeout = 0;
        timer = setInterval(() => {
          timeout++;
          myOrder(order_id).then((res) => {
            if (res.pay_status == 1) {
              this.ispaye();
              this.dialogVisiblepay = false;
              clearInterval(timer);
            }
          });
          if (timeout >= 30) {
            this.ispaye();
            clearInterval(timer);
            this.dialogVisiblepay = false;
          }
        }, 1000);
    },
    ispaye() {
      this.initData();
      this.step = 5;
      this.list[4].success = true;
    },
    // 生成二维码
    creatQrCode(text) {
      this.$refs.qrCodeDiv.innerHTML = text;
      new QRCode(this.$refs.qrCodeDiv, {
        text: text, // 需要转换为二维码的内容
        width: 150,
        height: 150,
        // render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
      });
    },
  },
};
</script>
<style>
.margin-left-30 {
  margin-left: 25px;
  color: #ff7476 !important;
}
.svg-icon {
  width: 200px;
  height: 200px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin: 50px 1px;
}
.zhifu {
  position: relative;
}
.zhifu img {
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>
<style scoped lang="less">
/deep/.el-upload-list {
  display: flex;
  flex-direction: column;
  height: auto;
}
/deep/.el-upload-list__item {
  text-align: start;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.shenhjrkr {
  margin: 50px 0 100px 0;

  img {
    width: 120px;
  }

  .renewradio {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
    height: 45px;
    background: #fff7e8;
    opacity: 1;
    border-radius: 4px;
    font-size: 14px;

    .renewradio_title {
      color: #409EFF;
      font-weight: bold;
    }
  }
}

#qrCode {
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid #194abe;
  margin: 10px 0;
}

.flex-left {
  display: flex;
  justify-content: start;
  padding-left: 68px;
}

//

/deep/.el-icon-check {
  // font-size: 50px;
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #f6f6f6;
      border: 1px solid #d4dbdd;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      border: 1px solid #3D63DF;
      background-color: #3D63DF;
    }

    .stponce {
      color: #fff;
      border: 1px solid #FF8640;
      background-color: #FF8640;
      font-family: Roboto;
      font-size: 32px;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
</style>
